export default __webpack_public_path__ + "static/media/reports.129c7012.png";